import React from 'react'

const Content = ({ className, children }) => {
  return <section className={`inner-page-area ${className}`}>{children}</section>
}

export default Content
